import type { FC, ReactElement } from "react";

import type { IconName } from "@similarweb/icons";

import BannerIcon from "app/pages/sales-intelligence/common-components/BannerIcon/BannerIcon";

import {
    StyledAccessBanner,
    StyledBannerBtnWrapper,
    StyledBannerContent,
    StyledBannerContentDescription,
    StyledBannerContentTitle,
    StyledIconWrapper,
} from "./styles";

type GrandAccessBannerProps = {
    title: string;
    description: string;
    button: ReactElement;
    iconName?: IconName;
    iconImagePath?: string;
    /** Rounded off where the banner floats inside a card or modal rather than filling a panel edge to edge. */
    isRounded?: boolean;
};

const GrandAccessBanner: FC<GrandAccessBannerProps> = ({
    title,
    description,
    iconImagePath,
    button,
    iconName,
    isRounded = false,
}) => (
    <StyledAccessBanner $isRounded={isRounded}>
        {iconName || iconImagePath ? (
            <StyledIconWrapper>
                <BannerIcon
                    iconName={iconName}
                    iconImagePath={iconImagePath}
                />
            </StyledIconWrapper>
        ) : null}
        <StyledBannerContent>
            <StyledBannerContentTitle>{title}</StyledBannerContentTitle>
            <StyledBannerContentDescription>{description}</StyledBannerContentDescription>
            <StyledBannerBtnWrapper>{button}</StyledBannerBtnWrapper>
        </StyledBannerContent>
    </StyledAccessBanner>
);

export default GrandAccessBanner;
